<template>
  <div>
    <div>
      <fieldset aria-labelledby="bookingHeading">
        <div class="small-form">
          <div id="privateCustomer" class="d-flex align-items-center">
            <input
              class="custom-radio"
              type="radio"
              name="personCheck"
              v-model="customerType"
              id="FP"
              value="FP"
              aria-labelledby="labelFP"
            />
            <label class="custom-radio-label" for="FP" id="labelFP">{{ $t('Private customer') }}</label>
          </div>
          <div id="businessCustomer" class="d-flex align-items-center">
            <input
              class="custom-radio"
              type="radio"
              name="personCheck"
              v-model="customerType"
              id="JP"
              value="JP"
              aria-labelledby="labelJP"
            />
            <label class="custom-radio-label" for="JP" id="labelJP">{{ $t('Business customer') }}</label>
          </div>
        </div>
      </fieldset>
    </div>
    <div v-if="customerType !== undefined">
      <!-- lang switch -->
      <div>
        <label class="heading-3" for="selectLanguage">{{ $t('Select the preferred language') }}</label>
        <div class="small-form">
          <select class="dropdown" id="selectLanguage" v-model="lang">
            <option disabled selected value="">{{ $t('Please select') }}</option>
            <option v-for="(language, index) in languages" :key="index" :value="language.value">{{
              $t(language.name)
            }}</option>
          </select>
        </div>
      </div>
      <!-- Service select -->
      <div>
        <label class="heading-3" for="selectService">{{ $t('You are interested in') }}:</label>
        <div class="small-form">
          <select class="dropdown" id="selectService" :disabled="Object.keys(services).length === 0" v-model="service">
            <option disabled selected value="">{{ $t('Please select') }}</option>
            <template v-if="services.length !== 0">
              <option v-for="(service, index) in services" :key="index" :value="service.appointment_type_group">{{
                service.name
              }}</option>
            </template>
          </select>
        </div>
      </div>
      <!-- Child number input -->
      <div style="margin-top: 40px" v-if="showChildInputFields">
        <label class="heading-3" for="childrenCount">{{ $t('please_select_for_how_many_children') }}</label>
        <div class="small-form" style="position: relative">
          <select class="dropdown" id="childrenCount" v-model="childrenCountComputed">
            <option disabled selected :value="null">{{ $t('Please select') }}</option>
            <option v-for="item in [1, 2, 3, 4, 5]" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <p class="input-error" style="bottom: initial" v-if="bookingErrors.includes('children')">{{
          $t('please_select_for_how_many_children')
        }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocaleOptions } from '../utils/countryConfig'
import { mapState, mapActions } from 'pinia'
import { useBookingStore, usePersonalStore } from '../store'
export default {
  name: 'ServiceSelect',
  data() {
    return {}
  },
  created() {
    if (this.customerType !== undefined && this.lang) {
      this.fetchServices()
    }
  },
  computed: {
    ...mapState(useBookingStore, [
      'services',
      'groupValue',
      'appCountry',
      'appointmentLang',
      'appointmentType',
      'appointmentTypeFromUrl',
      'showBranchSelect',
      'appLang',
      'selectedServiceObject',
      'branchType',
      'childrenCount',
      'bookingErrors',
    ]),
    customerType: {
      get() {
        return this.groupValue
      },
      set(value) {
        this.setCustomerType(value)
      },
    },
    service: {
      get() {
        return this.appointmentType
      },
      set(value) {
        this.setAppointmentType(value)
      },
    },
    lang: {
      get() {
        if (!this.appointmentLang) {
          const prefilledLang = this.prefilledLang()
          if (prefilledLang) {
            this.setAppointmentLang(prefilledLang)
          }
        }
        return this.appointmentLang
      },
      set(value) {
        this.setAppointmentLang(value)
      },
    },
    languages: {
      get() {
        return getLocaleOptions(this.appCountry)
      },
    },
    showChildInputFields() {
      if (
        this.selectedServiceObject &&
        (this.selectedServiceObject.show_child_input_branch || this.selectedServiceObject.show_child_input_video)
      ) {
        this.setChildInputs(true)
        return true
      } else {
        this.setChildInputs(false)
        return false
      }
    },
    childrenCountComputed: {
      get() {
        return this.childrenCount
      },
      set(value) {
        this.setChildrenCount(value)
      },
    },
  },
  watch: {
    lang: {
      handler: function () {
        this.getServicesData() // call it in the context of your component object
        this.clearBranchData() // hide branch select, clear branch selection data if changed
        this.resetPersonalState() // clear personal data
        //clear all child inputs related data
        this.setChildrenCount(null)
        this.setChildInputs(false)
        this.setChildrenArray([])
        this.setRepresentativeData({}) // clear representative data
      },
      deep: true,
    },
    customerType: {
      handler: function () {
        this.getServicesData() // call it in the context of your component object
        this.clearBranchData() // hide branch select, clear branch selection data if changed
        this.resetPersonalState() // clear personal data
        //clear all child inputs related data
        this.setChildrenCount(null)
        this.setChildInputs(false)
        this.setChildrenArray([])
        this.setRepresentativeData({}) // clear representative data
      },
      deep: true,
    },
    service: {
      handler: function () {
        this.setBranchType('') //clear selected branch type
        if (this.appointmentType !== '') {
          this.getSubUnitsData() // call it in the context of your component object
        }
        //get full service object
        let selectedServiceObject = null
        this.services.forEach((el) => {
          if (el.appointment_type_group == this.appointmentType) {
            selectedServiceObject = el
          }
        })
        //clear all child inputs related data
        this.setChildrenCount(null)
        this.setChildInputs(false)
        this.setChildrenArray([])
        this.resetPersonalState() // clear personal data
        this.setRepresentativeData({}) // clear representative data
        //set full selected service object in state
        this.setSelectedServiceObject(selectedServiceObject)
      },
      deep: true,
    },
  },
  methods: {
    fetchServices() {
      if (this.customerType !== undefined && this.lang && this.appCountry) {
        const lang = this.appLang
        const country = this.appCountry
        const groupValue = this.customerType
        const first = true
        const meetingLang = this.lang

        let getServiceObject = { groupValue, lang, country, first, meetingLang }
        // Make the API call to fetch services using getServiceObject
        this.getServices(getServiceObject).then(() => {
          // match service from url with fetched services
          const matchFound = this.services.some(
            (service) => service.appointment_type_group == this.appointmentTypeFromUrl
          )
          if (matchFound) {
            this.service = this.appointmentTypeFromUrl
          }
        })
      }
    },
    prefilledLang() {
      switch (this.appLang) {
        case 'lv_LV':
          return 'lv'
        case 'en_US':
          return 'en'
        case 'ru_RU':
          return 'ru'
        case 'et_EE':
          return 'et'
        case 'tt_RU':
          return 'ru'
        case 'lt_LT':
          return 'lt'
      }
    },
    ...mapActions(useBookingStore, [
      'getServices',
      'getSubUnits',
      'setCustomerType',
      'setAppointmentType',
      'setAppointmentLang',
      'setSelectedServiceObject',
      'setChildrenCount',
      'setChildInputs',
      'setChildrenArray',
      'toggleBranchSelect',
      'clearSubUnits',
      'deleteTimes',
      'clearMeetingDuration',
      'setSelectedBranch',
      'setBranchType',
      'setRepresentativeData',
    ]),
    ...mapActions(usePersonalStore, ['resetPersonalState']),
    /*
    ...mapMutationsBooking([
      'setCustomerType',
      'setAppointmentType',
      'setAppointmentLang',
      'setSelectedServiceObject',
      'setChildrenCount',
      'setChildInputs',
      'setChildrenArray',
    ]),
    */
    getServicesData() {
      if (this.lang !== '' && this.customerType !== '' && this.appCountry) {
        const lang = this.appLang
        const country = this.appCountry
        const groupValue = this.customerType
        const first = true
        const meetingLang = this.lang

        let getServiceObject = { groupValue, lang, country, first, meetingLang }
        /*
        if (!this.first && this.waitFor) {
          getServiceObject.subUnitId = this.waitFor
        }
        */
        this.getServices(getServiceObject)
      }
    },
    getSubUnitsData() {
      const lang = this.appLang
      const country = this.appCountry
      const groupValue = this.groupValue
      const first = false
      const appointmentTtypeId = this.appointmentType
      const meetingLang = this.lang

      let getServiceObject = { groupValue, lang, country, first, appointmentTtypeId, meetingLang }
      /*
      if (!this.first && this.waitFor) {
        getServiceObject.appointmentTtypeId = this.waitFor
      }
      */
      this.getSubUnits(getServiceObject)
    },
    clearBranchData() {
      if (this.showBranchSelect) {
        this.toggleBranchSelect(false) //hide branch select section
        this.setAppointmentType('') //reset service
        this.clearSubUnits() //clear sub-units
        this.deleteTimes() //clear all times
        this.clearMeetingDuration() //clear meeting durations
        this.setSelectedBranch('') //clear selected branch
        this.setBranchType('') //clear selected branch type
      }
    },
  },
}
</script>
